import {Sidebar} from "primereact/sidebar";
import {InputText} from "primereact/inputtext";
import {InputNumber} from "primereact/inputnumber";
import {Button} from "primereact/button";
import {Booking} from "../../data/Booking";
import {useEffect, useState} from "react";

interface BookingEditSidebarProps {
    visible: boolean;
    onHide: () => void;
    booking: Booking;
    onSave: (updatedBooking: Booking) => void;
}

function BookingEditSidebar({
                                visible,
                                onHide,
                                booking,
                                onSave,
                            }: BookingEditSidebarProps) {
    const [editedBooking, setEditedBooking] = useState<Booking>({...booking});

    useEffect(() => {
        setEditedBooking({...booking});
    }, [booking]);

    const handleSave = () => {
        onSave(editedBooking);
    };

    return (
        <Sidebar
            visible={visible}
            onHide={onHide}
            header="Buchung bearbeiten"
            position="right"
            style={{width: "30rem"}}
        >
            <div className="p-fluid">
                <div className="field">
                    <label htmlFor="name">Name</label>
                    <InputText
                        id="name"
                        value={editedBooking.name}
                        maxLength={128}
                        onChange={(e) =>
                            setEditedBooking({
                                ...editedBooking,
                                name: e.target.value,
                            })
                        }
                    />
                </div>
                <div className="field">
                    <label htmlFor="amount">Anzahl</label>
                    <InputNumber
                        id="amount"
                        value={editedBooking.amount}
                        onChange={(e) =>
                            setEditedBooking({
                                ...editedBooking,
                                amount: e.value as number,
                            })
                        }
                        showButtons
                        min={1}
                    />
                </div>
                <div className="field">
                    <label htmlFor="phone">Telefon</label>
                    <InputText
                        id="phone"
                        value={editedBooking.phone || ""}
                        maxLength={128}
                        onChange={(e) =>
                            setEditedBooking({
                                ...editedBooking,
                                phone: e.target.value,
                            })
                        }
                    />
                </div>
                <div className="field">
                    <label htmlFor="email">E-Mail</label>
                    <InputText
                        id="email"
                        value={editedBooking.email || ""}
                        maxLength={128}
                        onChange={(e) =>
                            setEditedBooking({
                                ...editedBooking,
                                email: e.target.value,
                            })
                        }
                    />
                </div>
                <div className="field">
                    <label htmlFor="comment">Kommentar</label>
                    <InputText
                        id="comment"
                        value={editedBooking.comment || ""}
                        maxLength={512}
                        onChange={(e) =>
                            setEditedBooking({
                                ...editedBooking,
                                comment: e.target.value,
                            })
                        }
                    />
                </div>
                <Button
                    label="Speichern"
                    icon="pi pi-check"
                    onClick={handleSave}
                    className="mt-3"
                />
            </div>
        </Sidebar>
    );
}

export default BookingEditSidebar;
